import { render, staticRenderFns } from "./formCard.vue?vue&type=template&id=3cbab36c"
import script from "./formCard.vue?vue&type=script&lang=js"
export * from "./formCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports